module.exports = __webpack_public_path__ + "img/Werk_NN_2b.d4d919bc.png";